<template>
  <div>
    子组件2: {{ $attrs }}
  </div>
</template>
<script>
export default {
  inheritAttrs: false
}
</script>
